import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const LoadableFilter = loadable(() =>
  import(/* webpackChunkName: "category" */ './filter')
);

export const HorizontalFilter = loadable(() =>
  import(/* webpackChunkName: "category" */ './horizontal-filter')
);

const Loader = props => (
  <div className={props.className}>
    <LoadableFilter {...props} />
  </div>
);

Loader.propTypes = {
  className: PropTypes.string.isRequired,
};

export default Loader;
